// extracted by mini-css-extract-plugin
export default {"container":"TitleWithLine_container__zO6hH","line":"TitleWithLine_line__PnWQ3","text":"TitleWithLine_text__kHtXZ"};